import { render } from "./Work.vue?vue&type=template&id=0ba31f1a&scoped=true&ts=true"
import script from "./Work.vue?vue&type=script&lang=ts"
export * from "./Work.vue?vue&type=script&lang=ts"

import "./Work.vue?vue&type=style&index=0&id=0ba31f1a&lang=scss&scoped=true"

import exportComponent from "/var/www/html/drupal/modules/custom/nvschade_calculator/assets/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ba31f1a"]])

export default __exports__